import { Back, gsap } from 'gsap';

const randomInteger = (minimum, maximum) => {
	let min = minimum;
	let max = maximum;

	if (maximum === undefined) {
		max = minimum;
		min = 0;
	}

	if (typeof min !== 'number' || typeof max !== 'number') {
		throw new TypeError('Expected all arguments to be numbers');
	}

	return Math.floor(Math.random() * (max - min + 1) + min);
};

Alpine.data('confetti', (id, delay = 0, confettiCount = 250) => {
	const confettiItems = [];

	return {
		activateConfetti() {
			if (this.$event.detail !== id) return;

			this.generateConfettiItems();

			setTimeout(() => {
				this.animateConfetti(confettiItems);
			}, delay);
		},

		generateConfettiItems() {
			const elementsClasses = [
				'confetti confetti--square',
				'confetti confetti--circle',
				'confetti confetti--triangle',
				'confetti confetti--star',
			];
			const colours = [
				'confetti--colour-1',
				'confetti--colour-2',
				'confetti--colour-3',
				'confetti--colour-4',
			];

			// Need a little timeout to get the client width of the confetti element.
			setTimeout(() => {
				const containerWidth = this.$refs.confetti.clientWidth;

				for (let i = 0; i < confettiCount; i += 1) {
					const shape =
						elementsClasses[randomInteger(0, elementsClasses.length - 1)];
					const colour = colours[randomInteger(0, colours.length - 1)];
					const item = document.createElement('div');

					// Set class name, and random position.
					item.setAttribute('class', `${shape} ${colour}`);
					item.style.top = `${randomInteger(-40, 40)}px`;
					item.style.left = `${randomInteger(0, containerWidth)}px`;

					this.$refs.confetti.appendChild(item);

					confettiItems.push(item);
				}
			});
		},

		animateConfetti() {
			for (let i = 0; i < confettiItems.length; i += 1) {
				const duration = randomInteger(100, 250) / 100;

				gsap.to(confettiItems[i], {
					keyframes: [
						{
							translateY: `-=${randomInteger(100, 400)}`,
							translateX: `-=${randomInteger(-150, 150)}`,
							scale: randomInteger(60, 90) / 100,
							delay: randomInteger(20, 100) / 100,
							rotationX: randomInteger(260, 560),
							rotationY: randomInteger(260, 560),
							rotationZ: randomInteger(260, 560),
							ease: Back.easeOut.config(2),
							opacity: 1,
							duration,
						},
						{
							opacity: 0,
							duration: randomInteger(25, 50) / 100,
							delay: (randomInteger(25, 40) / 100) * -1,
						},
					],
					onComplete() {
						// Delete the element from the DOM when done.
						const el = this._targets[0];

						el && el.remove();
					},
				});
			}
		},
	};
});
